import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "m29 18 8-8-8-8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 8.5a1.5 1.5 0 0 0 0 3zm34 0H2v3h34z"
    }, null, -1)
  ])))
}
export default { render: render }